import React, { useEffect, useState } from "react";
import strapiClient from "../strapiClient";
import { useParams } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";

// Function to render rich text content
const renderRichText = (content) => {
  if (!content || !Array.isArray(content)) return null;

  return content.map((block, index) => {
    switch (block.type) {
      case "paragraph":
        return (
          <p key={index}>
            {block.children?.map((child, childIndex) => {
              if (child.bold) {
                return <strong key={childIndex}>{child.text}</strong>;
              }
              return child.text || "";
            })}
          </p>
        );

      case "heading":
        const HeadingTag = `h${block.level || 3}`;
        return (
          <HeadingTag key={index}>
            {block.children?.map((child, childIndex) => {
              if (child.bold) {
                return <strong key={childIndex}>{child.text}</strong>;
              }
              return child.text || "";
            })}
          </HeadingTag>
        );

      case "list":
        const ListTag = block.format === "ordered" ? "ol" : "ul";
        return (
          <ListTag key={index}>
            {block.children?.map((item, itemIndex) => (
              <li key={itemIndex}>
                {item.children?.map((child, childIndex) => {
                  if (child.bold) {
                    return <strong key={childIndex}>{child.text}</strong>;
                  }
                  return child.text || "";
                })}
              </li>
            ))}
          </ListTag>
        );

      default:
        return null;
    }
  });
};

const BlogPost = () => {
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const { entryId } = useParams(); // Get the entry ID from the URL

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const response = await strapiClient.getArticle(entryId); // Fetch article by IdEntry
        // Since filtering returns an array, get the first (and should be only) result
        const article =
          response.data && response.data.length > 0 ? response.data[0] : null;
        setPost(article);
      } catch (error) {
        console.error("Error fetching blog post:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPost();
  }, [entryId]);

  if (loading)
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress color="inherit" style={{ color: "grey" }} />
      </div>
    );

  if (!post) return <p>Post not found</p>;

  return (
    <div>
      <h2>{post.Title}</h2>
      <div>{renderRichText(post.body)}</div>
    </div>
  );
};

export default BlogPost;
